/* global PCHUSER */

import $ from "vendor/zepto";
import UserService from "keno/app/services/User";
import EventsMixin from "keno/app/mixins/events";
import renderTemplate from "keno/app/modules/templateLoader";
import animationUtil from "keno/app/modules/animationUtil";

const NoPassword = function() {};

Object.assign(NoPassword.prototype, EventsMixin, {
	EVENTS: {
		CREATE_PASS: `onCreatePass`
	},
	constructor() {},
	mount(rootnode, redirectHome = true) {
		this.rootNode = document.querySelector(rootnode);
		// this.submitButton = this.rootNode.find(
		// 	`#sso-create-password-lightbox__submit-button`
		// );
		// this.passwordField = this.rootNode.find(
		// 	`#sso-create-password-lightbox-create-password`
		// );
		// this.confirmPasswordField = this.rootNode.find(
		// 	`#sso-create-password-lightbox-confirm-password`
		// );
		this.redirectHome = redirectHome;
		if (this.rootNode) {
			this.noPasswordSubmitBtn = this.rootNode.querySelector(
				`#gos__no-password-submit`
			);

			if (this.noPasswordSubmitBtn) {
				this.noPasswordSubmitBtn.addEventListener(
					`click`,
					this.onNoPasswordClick.bind(this),
					false
				);
			}

			this.noPasswordPassField = this.rootNode.querySelector(`.lbpassword`);
			if (this.noPasswordPassField) {
				this.noPasswordPassField.addEventListener(
					`keydown`,
					e => {
						if (e.keyCode === 13) {
							console.log(`enter pressed!`);
							this.onNoPasswordClick();
						}
					},

					//this.onNoPasswordClick.bind(this),
					false
				);
			}
			this.noPasswordConfirmPassField = this.rootNode.querySelector(
				`.lbconfirmPassword`
			);
			if (this.noPasswordConfirmPassField) {
				this.noPasswordConfirmPassField.addEventListener(
					`keydown`,
					e => {
						if (e.keyCode === 13) {
							// console.log( `enter pressed!` );
							this.onNoPasswordClick();
						}
					},

					//this.onNoPasswordClick.bind(this),
					false
				);
			}

			this.noPasswordNoThankYou = this.rootNode.querySelector(
				`.gos__bottom-text`
			);

			if (this.noPasswordNoThankYou) {
				this.noPasswordNoThankYou.addEventListener(`click`, () => {
					this.onNoPassForfeit();
				});
			}
			this.closeButton = this.rootNode.querySelector(`.modalClose`);
			if (this.closeButton) {
				this.closeButton.addEventListener(`click`, () => {
					this.onNoPassForfeit();
				});
			}
		}

		//if ( window.isMobile ) $( `.gos__button-container` ).before( $( `.gos__footer` ));
	},
	onNoPasswordClick() {
		if (window.isMobile) {
			this.mobileErrorContainer = $(`#notey`);
			this.errorHeaderText = $(`#notey .message`);
			this.errorOuterShell = $(`.sso-outer-shell`);
			this.errorInnerShell = this.errorOuterShell.find(`.inner-shell`);
		} else {
			this.errorContainer = $(`#sso-error-container`);
			this.errorHeaderText = this.errorContainer.find(`#sso-header-text`);
			this.errorOuterShell = $(`.sso-outer-shell`);
			this.errorInnerShell = this.errorOuterShell.find(`.inner-shell`);
		}

		if (this.validateFields()) {
			//pass password values from form

			var obj = new Object();
			obj.createPasswordController = Object.create(window.PCH.SSO.Controller);

			//Register Controller
			//clearing all errors manually since SSOlib isn't doing it for some reason
			obj.createPasswordController.init({
				//var controller = new PCH.SSO.Controller({
				elements: {
					container: $(".da-box"),
					password: $(".lbpassword"),
					confirmPassword: $(".lbconfirmPassword")
				},
				proxy: {
					createPassword: function(json) {
						//set flag to say password creation is going on

						obj.createPasswordController.showLoaderGraphic(true);

						//var reqObj = {Password:password, ConfirmPassword:confirmPassword, Persist:persist};
						var req = { obj: JSON.stringify(json) };
						//var req = json;
						//var req = Object.assign({}, json);
						//req._token = PCHSSOLightbox.getCsrfToken();
						//req = {obj:JSON.stringify(req)};
						jQuery.ajax({
							type: "GET",
							url:
								secure_url +
								PCHMINIBOOTSTRAP.ssouserBaseURL +
								"/ssoproxy/createpassword",
							contentType: "application/json; charset=utf-8",
							dataType: "jsonp",
							data: req,
							jsonpCallback: "cor",
							success: function(data) {
								obj.createPasswordController.showLoaderGraphic(false);
								obj.successCallBack(data);
							}
						});
					},
					redirect: function(url) {
						if (typeof url !== "undefined") {
							window.location.href = url;
						}
						return false;
					}
				},
				ui: PCH.ssoui,
				success: function() {
					if (typeof obj.onSuccessCallBack === "function") {
						obj.onSuccessCallBack();
					}
				},
				failure: function() {
					PCHSSOProxy.createPasswordInProgress = false;
					obj.createPasswordController.showLoaderGraphic(false);
					if (
						obj.createPasswordController._elements.container.hasClass("da-box")
					) {
						PCHSSOProxy.setButtonStatus(
							obj.createPasswordController._elements.container.find(
								"button.submit"
							),
							1
						);
					} else if (
						obj.createPasswordController._elements.container.find(
							".play_more_button"
						).length != 0
					) {
						$(".play_more_button").removeClass("disabled");
					}
				},
				env: PCH.env
			});
			obj.successCallBack = function(json) {
				var response = json.ValidationResponses;
				if (response.IsValid) {
					PCHUSER.type = 2; //user is registered now, can show token toasts
					this.fireEvent(this.EVENTS.CREATE_PASS);
				} else {
					this.showErrors(response.FieldOrDatabaseValidationResponse.Responses);
					PCHSSOProxy.createPasswordInProgress = false; //lets give the user the option to try again
				}
			}.bind(this);

			obj.createPasswordController.createPassword();
		}
	},
	showErrors(errorResponses) {
		this.errorHeaderText.html(`Please correct Below and Re-Submit: `);
		this.positionErrorContainer();
		this.populateErrorResponses(errorResponses);
	},
	validateFields() {
		let valid = true;
		let errorHTML = ``;

		if (this.noPasswordPassField.value === ``) {
			this.noPasswordPassField.classList += ` invalid`;

			errorHTML += `<div class="error">Password</div>`;
			valid = false;
		}
		if (this.noPasswordConfirmPassField.value === ``) {
			this.noPasswordConfirmPassField.classList += ` invalid`;
			errorHTML += `<div class="error">Password Confirmation</div>`;
			valid = false;
		}

		if (!valid) {
			this.errorHeaderText.html(`Please Fill in the Following Fields:`);
			this.errorInnerShell.html(errorHTML);

			this.positionErrorContainer();

			this.showErrorContainer();
		}
		return valid;
	},
	positionErrorContainer() {
		if (this.errorContainer) {
			const offsetTop = this.noPasswordConfirmPassField.getBoundingClientRect()
				.top;
			const offsetLeft =
				this.noPasswordConfirmPassField.offsetLeft +
				this.noPasswordConfirmPassField.clientWidth;

			this.errorContainer.css(`top`, offsetTop);
			this.errorContainer.css(`left`, offsetLeft);
		}
	},
	populateErrorResponses(errorResponses) {
		let errorHTML = ``;

		if (errorResponses) {
			errorResponses.forEach(function(errorResponse) {
				errorHTML += `<div class="error">` + errorResponse.Message + `</div>`;
			});
		} else {
			errorHTML = `<div class="error">Technical Difficulty - Please Try Again</div>`;
		}

		this.errorInnerShell.html(errorHTML);

		this.positionErrorContainer();

		this.showErrorContainer();
	},
	showErrorContainer() {
		if (window.isMobile) {
			this.mobileErrorContainer.show();
			this.errorHeaderText.css(`opacity`, 1);
			this.errorOuterShell.show();
		} else {
			this.errorContainer.show();
		}
	},
	onNoPassForfeit() {
		this.fireEvent(this.EVENTS.FORFEIT);
		if (this.redirectHome) {
			window.location = `/`;
		}
	},

	// @override
	open() {
		const inline = !!this.gameNode;

		//allow redirect on live drawing now

		this.showing = true;
		this.view = $(
			renderTemplate(`shared/gos-no-password.html`, {
				inline: inline,
				totalTokens: this.opts.totalTokens || 0
			})
		);

		if (inline) {
			const gameNode = $(this.gameNode);
			//append to first child in gamenode which is from the scratch card package

			this.gameContainer = $(gameNode.children(`div`)[0]);
			if (this.gameContainer.length === 0) {
				this.gameContainer = $(gameNode.children(`section`)[0]);
			}
			this.gameContainer.append(this.view.get(0));

			animationUtil.animateFast(this.view, animationUtil.ANIMS.FADE_IN_DOWN);
			this.view.on(`click`, `[data-dismiss="modal"]`, e => {
				e.preventDefault();
				this.dispatchEvent(this.EVENTS.CONTINUE);
			});
		} else {
			document.body.appendChild(this.view.get(0));
			this.view.modal({ backdrop: false });
			this.view.on(`hiddenbsmodal`, function() {
				this.view.remove();
			});
		}
	},
	//@override
	close() {
		animationUtil.animateFast(this.view, animationUtil.ANIMS.FADE_OUT, () => {
			this.view.removeClass(`gos--show`);
		});
	},

	onBackHomeClick(ev) {
		ev.preventDefault();
		this.fireEvent(this.EVENTS.BACK_HOME);
	}
});

export default NoPassword;
